/* eslint-disable */

// Custom getPaidol used by the company switcher to hydrate selectedPaidol when
// a support user lands on a paidol they don't have a PaidolUser row for.
// Field set mirrors the V2Paidol shape downstream code expects, minus
// V2-only fields (`type`, `enablePayables`) that don't exist on the
// Amplify auto-gen `Paidol` type. Re-adding either field will fail
// validation on environments where the Amplify Paidol model lacks them
// (every env today). Migrate to a CDK `getV2Paidol` resolver to converge.
export const getPaidolForSwitcher = /* GraphQL */ `
  fragment CodingColumnSettingsFields on CodingColumnSettings {
    visibility
    order
    customLabel
    defaultValue {
      id
      label
    }
    isRequired
  }
  fragment CodingFilteringSettingsFields on CodingFilteringSettings {
    isAllAvailable
    ids
  }
  query GetPaidolForSwitcher($id: ID!) {
    getPaidol(id: $id) {
      id
      name
      slug
      logoUrl
      enablePCards
      isConstructionType
      isAgaveClient
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      isProcoreClient
      agaveAccountToken
      agave_data_sync_in_progress
      agaveSourceSystemSlug
      erpSpeedchain
      erpConnectionId
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      firstRunChecklist {
        connectFinancialAccount
        addAdmin
        addTeamMember
        createSpendRule
        issueCard
        createGroup
        setReimbursement
        integrateERP
        dismissWelcomePage
        isStepperComplete
      }
      codingColumnsConfig {
        isEnabled
        glCode {
          ...CodingColumnSettingsFields
        }
        project {
          ...CodingColumnSettingsFields
        }
        costCode {
          ...CodingColumnSettingsFields
        }
        costType {
          ...CodingColumnSettingsFields
        }
        vendor {
          ...CodingColumnSettingsFields
        }
        subJob {
          ...CodingColumnSettingsFields
        }
        location {
          ...CodingColumnSettingsFields
        }
        department {
          ...CodingColumnSettingsFields
        }
        employee {
          ...CodingColumnSettingsFields
        }
        accountingDate {
          ...CodingColumnSettingsFields
        }
        subaccount {
          ...CodingColumnSettingsFields
        }
        jobCode {
          ...CodingColumnSettingsFields
        }
        billableItem {
          ...CodingColumnSettingsFields
        }
        transactionType {
          ...CodingColumnSettingsFields
        }
        equipment {
          ...CodingColumnSettingsFields
        }
        emCostCode {
          ...CodingColumnSettingsFields
        }
        emCostType {
          ...CodingColumnSettingsFields
        }
      }
      codingRequirements {
        isEnabled
        groups {
          columns
        }
      }
      glCodeVisibilitySettings {
        ...CodingFilteringSettingsFields
      }
      projectVisibilitySettings {
        ...CodingFilteringSettingsFields
      }
      locationVisibilitySettings {
        ...CodingFilteringSettingsFields
      }
      sage300PostingSettings {
        isEnabled
      }
      qboPostingSettings {
        isEnabled
      }
      qboAnyCodingPostingSettings {
        isEnabled
      }
      erpCostCodesUseDescriptionSetting {
        isEnabled
      }
      erpDropdownSortByCodeSetting {
        isEnabled
      }
      erpDepartmentLocationSetting {
        isEnabled
        departmentEnabled
        locationEnabled
        filterProjectsByEmployeeLocationEnabled
      }
      accountingDateSettings {
        isEnabled
      }
      receiptAgentSettings {
        isEnabled
      }
      receiptsSettings {
        isEnabled
        minimumAmount
        exemptCardIds
      }
      reimbursementSettings {
        isEnabled
        mileageRate
        mileageRateEffectiveFrom
      }
      fuelCaptureSettings {
        isEnabled
        isVehicleIdRequired
        isGallonsRequired
        isOdometerRequired
        isMCC5541Required
        isMCC5542Required
      }
      cardLockSettings {
        isEnabled
        daysToLock
        isReceiptsRequired
        isNotesRequired
        isFuelCaptureRequired
        applyImmediately
        disableAutoUnlock
        includePendingCharges
      }
      sessionTimeoutSettings {
        isEnabled
        timeoutMinutes
      }
      approvalWorkflowSettings {
        isEnabled
        approvalLevels
        groupApprovalsEnabled
      }
      editLockingSettings {
        isEnabled
      }
      requireProjectBeforeCostCode {
        isEnabled
      }
      scopeEquipmentCodesToEmDepartment {
        isEnabled
      }
      notesSettings {
        isEnabled
      }
      flexCodingSettings {
        isEnabled
      }
      flexFieldSettings {
        isEnabled
      }
      jobCodeSettings {
        isEnabled
      }
      glCodeFilteringByUser {
        isEnabled
      }
      projectFilteringByUser {
        isEnabled
      }
      locationFilteringByUser {
        isEnabled
      }
      departmentFilteringByUser {
        isEnabled
      }
      creditLimit
      paymentTermDays
      createdAt
      updatedAt
    }
  }
`;

export const v2SearchAgaveGLCodesCustom = /* GraphQL */ `
  query V2SearchAgaveGLCodes($input: SearchAgaveGLCodesInput!) {
    v2SearchAgaveGLCodes(input: $input) {
      items {
        id
        paidolId
        authPaidolId
        source_id
        classification
        currency_code
        current_balance
        description
        name
        number
        status
        type
        source_create_time
        source_update_time
        createdAt
        updatedAt
        fullName
        source_data {
          data
        }
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;

export const v2GetAgaveGlCodesByCostingCustom = /* GraphQL */ `
  query V2GetAgaveGlCodesByCosting($input: GetAgaveGlCodesByCostingInput!) {
    v2GetAgaveGlCodesByCosting(input: $input) {
      items {
        id
        paidolId
        authPaidolId
        source_id
        classification
        currency_code
        current_balance
        description
        name
        number
        status
        type
        source_create_time
        source_update_time
        createdAt
        updatedAt
        fullName
        source_data {
          data
        }
        __typename
      }
      total
      __typename
    }
  }
`;

export const v2SearchAgaveProjectsCustom = /* GraphQL */ `
  query V2SearchAgaveProjects($input: SearchAgaveProjectsInput!) {
    v2SearchAgaveProjects(input: $input) {
      items {
        id
        paidolId
        authPaidolId
        source_id
        amount
        completion_date
        name
        number
        start_date
        status
        type
        source_create_time
        source_update_time
        createdAt
        updatedAt
        fullName
        source_data {
          data
        }
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;

export const v2SearchAgaveCostCodesCustom = /* GraphQL */ `
  query V2SearchAgaveCostCodes($input: SearchAgaveCostCodesInput!) {
    v2SearchAgaveCostCodes(input: $input) {
      items {
        id
        paidolId
        authPaidolId
        source_id
        asset_account_id
        formatted_full_code
        code
        full_code
        cost_unit_of_measure
        description
        expense_account_id
        income_account_id
        name
        parent_id
        project_id
        price_unit_of_measure
        source_create_time
        source_update_time
        status
        type
        unit_cost
        unit_price
        vendor_id
        sub_job_id
        createdAt
        updatedAt
        fullName
        cost_type_ids
        source_data {
          data
        }
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;

export const v2SearchAgaveVendorsCustom = /* GraphQL */ `
  query V2SearchAgaveVendors($input: SearchAgaveVendorsInput!) {
    v2SearchAgaveVendors(input: $input) {
      items {
        id
        paidolId
        authPaidolId
        source_id
        address {
          street_1
          street_2
          city
          state
          country
          postal_code
        }
        code
        email
        fax
        name
        phone
        status
        tax_number
        terms
        type
        website
        source_create_time
        source_update_time
        source_data {
          V1099YN
          V1099Type
          V1099Box
          EFT
          data
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;

export const v2SearchAgaveCostTypesCustom = /* GraphQL */ `
  query V2SearchAgaveCostTypes($input: SearchAgaveCostTypesInput!) {
    v2SearchAgaveCostTypes(input: $input) {
      items {
        id
        paidolId
        authPaidolId
        source_id
        code
        name
        project_id
        source_create_time
        source_update_time
        source_data {
          path
          content_type
          data
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;

export const v2SearchAgaveSubJobsCustom = /* GraphQL */ `
  query V2SearchAgaveSubJobs($input: SearchAgaveSubJobsInput!) {
    v2SearchAgaveSubJobs(input: $input) {
      items {
        id
        agaveSubJobId
        paidolId
        authPaidolId
        source_id
        code
        name
        number
        status
        type
        source_create_time
        source_update_time
        source_data {
          path
          content_type
          data
        }
        createdAt
        updatedAt
        projectId
        fullName
        cost_code_ids
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;

export const v2SearchAgaveLocationsCustom = /* GraphQL */ `
  query V2SearchAgaveLocations($input: SearchAgaveLocationsInput!) {
    v2SearchAgaveLocations(input: $input) {
      items {
        id
        paidolId
        authPaidolId
        name
        parent_id
        source_id
        source_create_time
        source_update_time
        source_data
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;

export const v2SearchAgaveDepartmentsCustom = /* GraphQL */ `
  query V2SearchAgaveDepartments($input: SearchAgaveDepartmentsInput!) {
    v2SearchAgaveDepartments(input: $input) {
      items {
        id
        paidolId
        authPaidolId
        code
        name
        status
        type
        source_id
        source_create_time
        source_update_time
        source_data
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;

export const v2SearchAgaveSubaccountsCustom = /* GraphQL */ `
  query V2SearchAgaveSubaccounts($input: SearchAgaveSubaccountsInput!) {
    v2SearchAgaveSubaccounts(input: $input) {
      items {
        id
        paidolId
        authPaidolId
        code
        name
        status
        type
        source_id
        source_create_time
        source_update_time
        source_data
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;

export const v2SearchAgaveEmployeesCustom = /* GraphQL */ `
  query V2SearchAgaveEmployees($input: SearchAgaveEmployeesInput!) {
    v2SearchAgaveEmployees(input: $input) {
      items {
        id
        paidolId
        authPaidolId
        name
        fullName
        firstName
        lastName
        email
        status
        source_id
        source_create_time
        source_update_time
        source_data
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;

export const PaymentFileQueuesByPaidol = /* GraphQL */ `
  query PaymentFileQueuesByPaidol(
    $paidol_id: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFileQueueFilterInput
    $limit: Int
    $nextToken: String
  ) {
    paymentFileQueuesByPaidol(
      paidol_id: $paidol_id
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        key
        status
        priority_status
        processed_at
        paidol_id
        createdAt
        updatedAt
        error_messages
        num_vendors
        num_payments
        num_success
        num_failed
        total {
          value
          currency
        }
        user {
          username
        }
      }
      nextToken
    }
  }
`;

//obsolete
export const getPaidolVendor = /* GraphQL */ `
  query GetPaidolVendor($id: ID!) {
    getPaidolVendor(id: $id) {
      id
      user_vendor_id
      paidol_id
      is_migration
      vendor {
        id
        slug
        legal_name
        account_balance
        name
        dba
        ein
        mcc
        corp_type
        industry
        company_email
        customer_facing_email
        company_phone
        website
        company_address {
          address1
          address2
          city
          state
          country
          postal_code
        }
        customer_facing_address {
          address1
          address2
          city
          state
          country
          postal_code
        }
        legal_address {
          address1
          address2
          city
          state
          country
          postal_code
        }
        priority_status
        company_id
        priority_response
        createdAt
        updatedAt
      }
      vendor_paidol_id
      payment_terms
      contact_name
      priority_response
      cron_status
      priority_status
      priority_supplier_id
      createdAt
      updatedAt
      bankAccounts {
        bankId
        accountType
        accountNumber
        routingNumber
        defaults
      }
      achEnabled
      virtualCardEnabled
    }
  }
`;

//obsolete
export const SupplierFileQueuesByPaidol = /* GraphQL */ `
  query SupplierFileQueuesByPaidol(
    $paidol_id: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSupplierFileQueueFilterInput
    $limit: Int
    $nextToken: String
  ) {
    supplierFileQueuesByPaidol(
      paidol_id: $paidol_id
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        key
        status
        processed_at
        paidol_id
        createdAt
        updatedAt
        error_messages
        num_vendors
        num_success
        num_failed
        user {
          username
        }
      }
      nextToken
    }
  }
`;

//obsolete
export const vendorByPaidol = /* GraphQL */ `
  query VendorByPaidol(
    $paidol_id: ID!
    $user_vendor_id: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaidolVendorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    vendorByPaidol(
      paidol_id: $paidol_id
      user_vendor_id: $user_vendor_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        user_vendor_id
        paidol_id
        vendor {
          id
          id_base58
          id_base58_short
          slug
          legal_name
          account_balance
          name
          dba
          ein
          mcc
          corp_type
          industry
          company_email
          customer_facing_email
          company_phone
          website
          company_address {
            address1
            address2
            city
            state
            country
            postal_code
          }
          admin_user_id
          accounts_payable_user_id
          accounts_receivable_user_id
          low_balance_alert_threshold
          speedscore
          priority_status
          priority_buyer_id
          deleted_at
          company_id
          logo
          priority_response
          type
          achEnabled
          virtualCardRequested
          virtualCardEnabled
          achRequested
          cron_status
          createdAt
          updatedAt
        }
        vendor_paidol_id
        priority_active
        payment_terms
        priority_account_balance
        contact_name
        priority_billing_code
        priority_repeate_code
        priority_group_code
        email_addresses
        priority_document_delivery
        priority_regular_inv
        priority_summary_inv
        foreign_name
        remarks
        box_1099
        form_code_1099
        remark_1
        priority_response
        cron_status
        priority_status
        priority_supplier_id
        virtual_card_email
        bankAccounts {
          bankId
          accountType
          accountNumber
          routingNumber
          defaults
        }
        achEnabled
        virtualCardEnabled
        is_migration
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const v2GetProjectGroup = /* GraphQL */ `
  query V2GetProjectGroup($input: GetProjectGroupInput!) {
    v2GetProjectGroup(input: $input) {
      projectGroup {
        id
        paidolId
        authPaidolId
        name
        groupProjects
        isMonthlyBudgetUnlimited
        spendGroupId
        monthlyBudget {
          value
          currency
        }
        monthlyBudgetSpend {
          items {
            yearAndMonth
            amount
          }
          nextToken
        }
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      projects {
        id
        name
        __typename
      }
      groupAdmins {
        id
        paidolId
        paidolUserId
        projectGroupId
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;

export const v2GetReceiptUpload = /* GraphQL */ `
  query V2GetReceiptUpload($input: GetReceiptUploadInput!) {
    v2GetReceiptUpload(input: $input) {
      id
      paidolId
      authPaidolId
      document
      status
      summaryFields {
        nextToken
        __typename
      }
      lineItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
    }
  }
`;

export const v2GetReceiptsByTransactionId = /* GraphQL */ `
  query V2GetReceiptsByTransactionId($input: GetReceiptsByTransactionIdInput!) {
    v2GetReceiptsByTransactionId(input: $input) {
      items {
        id
        paidolId
        authPaidolId
        document
        status
        summaryFields {
          nextToken
          __typename
        }
        lineItems {
          nextToken
          __typename
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const v2SearchStatementSummaries = /* GraphQL */ `
  query V2SearchStatementSummaries($input: SearchStatementSummariesInput!) {
    v2SearchStatementSummaries(input: $input) {
      items {
        __typename
        id
        paidolId
        authPaidolId
        startDate
        endDate
        statementBalance
        pdfLink
        createdAt
        updatedAt
      }
      nextToken
      total
      __typename
    }
  }
`;

export const checkMigrateERPEndpointSettings = /* GraphQL */ `
  query MigrateERPEndpointSettings($input: String!) {
    migrateERPEndpointSettings(input: $input) {
      migrated
      paidol {
        id
        erpProjectsEndpointSetting {
          selectedEndpoint
          isEnabled
          shouldDisplay
        }
      }
    }
  }
`;

export const listHighnoteDisputeEventsByPaidolIdCustom = /* GraphQL */ `
  query ListHighnoteDisputeEventsByPaidolId(
    $paidolId: ID!
    $eventDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    listHighnoteDisputeEventsByPaidolId(
      paidolId: $paidolId
      eventDate: $eventDate
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        disputeId
        transactionEventId
        amount {
          value
          currencyCode
        }
        status
        creditStatus
        category
        liability
        enableListing
        eventType
        eventDate
      }
      nextToken
    }
  }
`;

// SEE-1053: slim posting-status read for the direct-ERP async posting poll
// (Sage 300 via hh2). Polled by the frontend while a posting is PENDING —
// same pattern as the ERP sync status poll, chosen over a subscription for
// observability (visible in the network tab) and refresh-resilience.
export const getHighnoteTransactionEventPostingStatus = /* GraphQL */ `
  query GetHighnoteTransactionEvent($id: ID!) {
    getHighnoteTransactionEvent(id: $id) {
      id
      erpPostingStatus
      erpPostingError
      erpPostingWarning
      erpApprovalStatus
      agaveExpenseId
    }
  }
`;

// SEE-1377: one-shot read of a receipts-download queue row, fired right
// after the sheet subscribes to it. The streamed export can finish in a few
// seconds — faster than the subscription websocket is established — so a
// PROCESSED/ERROR update can land before we are listening. This catch-up
// read closes that race.
export const getTransactionsReceiptsDownloadQueueById = /* GraphQL */ `
  query GetTransactionsReceiptsDownloadQueue($id: ID!) {
    getTransactionsReceiptsDownloadQueue(id: $id) {
      id
      user_id
      paidol_id
      paidolUserId
      s3_key
      range_option
      start_date
      end_date
      cron_status
      error_code
      createdAt
      filteredTransactionIds
      updatedAt
      __typename
    }
  }
`;

// SEE-1235: the transactions export's catch-up read, polled while the export is pending
// (useCatchUpWhilePending). Owner-scoped on Amplify, like the receipts one above: only the
// requester reads their row.
export const getTransactionsDownloadQueueById = /* GraphQL */ `
  query GetTransactionsDownloadQueue($id: ID!) {
    getTransactionsDownloadQueue(id: $id) {
      id
      s3_key
      cron_status
      mark_as_exported
      exported_count
      skipped_count
    }
  }
`;

// SEE-1412: a copy of the auto-generated `getHighnoteTransactionEvent` document with the
// cardholder's owner-only PII removed from the nested `user` selection — birthdate, address,
// phone_number, finicityCustomerId, dwollaCustomerId.
//
// SEE-1310 made those five fields owner-only on User, so an admin opening a CARDHOLDER's
// transaction got `Unauthorized` on each one. Harmless in effect (AppSync returns the rest of the
// payload and nulls just those fields, so the review mutation still succeeded) but it surfaced as
// an error in the UI, and the app never read the fields in the first place — they were fetched and
// discarded. A transaction-review screen has no business reading someone's date of birth.
//
// Deliberately a faithful copy minus those five lines rather than a minimal selection: this is a
// bug fix, and reducing the field set further risks dropping something a consumer needs. Trimming
// the rest of the over-selection is worthwhile follow-up work, not this ticket.
export const getHighnoteTransactionEventForReview = /* GraphQL */ `
  query GetHighnoteTransactionEventForReview($id: ID!) {
    getHighnoteTransactionEvent(id: $id) {
      id
      transactionId
      transaction {
        transactionId
        paymentCardId
        paidolId
        authPaidolId
        cardGroupId
        status
        transactionDate
        merchantName
        merchantCategoryCode
        merchantCategory
        transactionEvents
        note
        jobCodeId
        procoreCompanyId
        procoreProjectId
        procoreWBSCodeId
        procoreDirectCostId
        procoreDirectCostLineItemId
        agaveProjectId
        agaveCostCodeId
        agaveCostTypeId
        agaveExpenseId
        agaveVendorId
        agaveGlCodeId
        agaveDepartmentId
        agaveLocationId
        agaveSubaccountId
        receiptPath
        receiptId
        erpApprovalStatus
        erpBypassStatus
        last4
        userId
        email
        approvedAmountValue
        approvedAmountCurrencyCode
        flexCodeId
        flexCostCodeId
        flexCostTypeId
        flexGlCodeId
        flexVendorId
        selectedCodingOption
        agaveGlCostTypeId
        flexCodeTransactionStatus
        approveWithoutNotes
        approveWithoutReceipts
        fuelVehicleId
        fuelOdometerReading
        fuelGallons
        fuelCostPerGallon
        createdAt
        updatedAt
        __typename
      }
      paymentCardId
      paymentCard {
        paymentCardId
        paidolId
        authPaidolId
        name
        cardGroupId
        status
        bin
        last4
        network
        formFactor
        expirationDate
        hasPin
        cardholderId
        cardholderName
        isAdminLocked
        lastActionByRole
        lastActionByPaidolUserId
        merchantSpendRuleId
        isAuthorizedUserCard
        createdAt
        updatedAt
        __typename
      }
      paidolId
      reconciliationId
      authPaidolId
      eventDate
      processedAt
      origin
      status
      partial
      settlementImpact
      approvedAmount {
        value
        currencyCode
        decimalPlaces
        __typename
      }
      fees {
        value
        currencyCode
        decimalPlaces
        __typename
      }
      approvedAmountValue
      approvedAmountCurrencyCode
      eventData
      transactionOldState
      transactionNewState
      enableListing
      email
      userId
      user {
        id
        username
        email
        first_name
        middle_name
        last_name
        suffix
        picture
        is_speedster
        phone_extension
        password_updated_at
        is_support
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      last4
      card {
        paymentCardId
        paidolId
        authPaidolId
        name
        cardGroupId
        status
        bin
        last4
        network
        formFactor
        expirationDate
        hasPin
        cardholderId
        cardholderName
        isAdminLocked
        lastActionByRole
        lastActionByPaidolUserId
        merchantSpendRuleId
        isAuthorizedUserCard
        createdAt
        updatedAt
        __typename
      }
      cardGroupId
      cardGroup {
        id
        paidolId
        authPaidolId
        name
        groupProjects
        isMonthlyBudgetUnlimited
        spendGroupId
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      merchantCategory
      merchantCategoryCode
      merchantName
      jobCodeId
      jobCode {
        id
        paidolId
        authPaidolId
        description
        code
        isActive
        budget
        jobCodeImportId
        createdAt
        updatedAt
        __typename
      }
      flexCodeTransactionStatus
      workflowStatus
      returnedStatus
      flexCodeId
      flexCode {
        id
        paidolId
        authPaidolId
        projectName
        projectCode
        isActive
        flexCodeImportId
        createdAt
        updatedAt
        __typename
      }
      flexCostCodeId
      flexCostCode {
        id
        paidolId
        authPaidolId
        code
        flexCodeImportId
        createdAt
        updatedAt
        __typename
      }
      flexCostTypeId
      flexCostType {
        id
        paidolId
        authPaidolId
        name
        flexCodeImportId
        createdAt
        updatedAt
        __typename
      }
      flexGlCodeId
      flexGlCode {
        id
        paidolId
        authPaidolId
        name
        flexCodeImportId
        createdAt
        updatedAt
        __typename
      }
      flexVendorId
      flexVendor {
        id
        paidolId
        authPaidolId
        name
        flexCodeImportId
        createdAt
        updatedAt
        __typename
      }
      agaveDepartment {
        id
        paidolId
        authPaidolId
        code
        name
        fullName
        status
        type
        source_id
        source_create_time
        source_update_time
        createdAt
        updatedAt
        source_data
        relatedIds
        __typename
      }
      agaveDepartmentId
      agaveLocation {
        id
        paidolId
        authPaidolId
        name
        fullName
        parent_id
        source_id
        source_create_time
        source_update_time
        createdAt
        updatedAt
        source_data
        relatedIds
        __typename
      }
      agaveLocationId
      agaveSubaccount {
        id
        paidolId
        authPaidolId
        code
        name
        status
        type
        source_id
        source_create_time
        source_update_time
        createdAt
        updatedAt
        source_data
        __typename
      }
      agaveSubaccountId
      agaveEmployee {
        id
        paidolId
        authPaidolId
        name
        fullName
        firstName
        lastName
        email
        status
        source_id
        source_create_time
        source_update_time
        createdAt
        updatedAt
        source_data
        __typename
      }
      agaveEmployeeId
      agaveExpense {
        id
        source_id
        amount
        amount_due
        ap_payment_ids
        batch
        batch_id
        creator_id
        currency_code
        description
        discount_amount
        discount_date
        due_date
        issue_date
        misc_amount
        net_amount
        number
        project_id
        retention_amount
        retention_percent
        status
        subtotal_amount
        tax_amount
        total_amount
        type
        vendor_id
        source_create_time
        source_update_time
        __typename
      }
      agaveExpenseId
      agaveProject {
        id
        paidolId
        authPaidolId
        source_id
        amount
        completion_date
        name
        number
        start_date
        status
        type
        source_create_time
        source_update_time
        createdAt
        updatedAt
        fullName
        relatedIds
        __typename
      }
      agaveProjectId
      agaveCostCode {
        id
        paidolId
        authPaidolId
        asset_account_id
        source_id
        formatted_full_code
        code
        full_code
        cost_unit_of_measure
        description
        expense_account_id
        income_account_id
        name
        parent_id
        project_id
        price_unit_of_measure
        source_create_time
        source_update_time
        status
        type
        unit_cost
        unit_price
        vendor_id
        sub_job_id
        createdAt
        updatedAt
        projectId
        paidolProject
        projectIds
        cost_type_ids
        fullName
        __typename
      }
      agaveCostCodeId
      agaveCostTypeId
      agaveCostType {
        id
        paidolId
        authPaidolId
        source_id
        code
        name
        project_id
        source_create_time
        source_update_time
        createdAt
        updatedAt
        projectId
        paidolProject
        __typename
      }
      agaveGlCode {
        id
        paidolId
        authPaidolId
        source_id
        classification
        currency_code
        current_balance
        description
        name
        number
        status
        type
        source_create_time
        source_update_time
        createdAt
        updatedAt
        fullName
        relatedIds
        __typename
      }
      agaveGlCodeId
      agaveVendor {
        id
        paidolId
        authPaidolId
        source_id
        code
        email
        fax
        name
        phone
        status
        tax_number
        terms
        type
        website
        source_create_time
        source_update_time
        createdAt
        updatedAt
        fullName
        __typename
      }
      agaveVendorId
      agaveSubJob {
        id
        agaveSubJobId
        paidolId
        authPaidolId
        source_id
        name
        number
        code
        status
        type
        source_create_time
        source_update_time
        createdAt
        updatedAt
        projectId
        fullName
        cost_code_ids
        __typename
      }
      agaveSubJobId
      agaveEquipment {
        id
        paidolId
        authPaidolId
        source_id
        code
        name
        fullName
        emGroup
        emCo
        category
        department
        status
        source_create_time
        source_update_time
        lastSeenAt
        createdAt
        updatedAt
        __typename
      }
      agaveEquipmentId
      agaveEmCostCode {
        id
        paidolId
        authPaidolId
        source_id
        code
        name
        fullName
        emGroup
        emCostTypeCodes
        source_create_time
        source_update_time
        lastSeenAt
        createdAt
        updatedAt
        __typename
      }
      agaveEmCostCodeId
      agaveEmCostType {
        id
        paidolId
        authPaidolId
        source_id
        code
        name
        fullName
        emGroup
        abbreviation
        source_create_time
        source_update_time
        lastSeenAt
        createdAt
        updatedAt
        __typename
      }
      agaveEmCostTypeId
      codingType
      accountingDate
      procoreDirectCostId
      procoreDirectCostLineItemId
      procoreProject {
        id
        active
        display_name
        name
        created_at
        start_date
        completion_date
        project_number
        total_value
        __typename
      }
      procoreProjectId
      procoreWBSCode {
        id
        flat_code
        flat_name
        description
        status
        __typename
      }
      procoreWBSCodeId
      erpApprovalStatus
      erpBypassStatus
      erpBillableItemId
      erpBillableItemName
      erpBillable
      erpPostingStatus
      erpPostingError
      erpPostingWarning
      sage300APInvoiceStatus
      sage300APInvoiceError
      note
      approveWithoutNotes
      receiptPath
      receiptId
      receipt {
        id
        paidolId
        authPaidolId
        document
        status
        createdAt
        updatedAt
        __typename
      }
      hasReceipt
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      codedAt
      codingMethod
      receiptUploadedAt
      receiptUploadMethod
      createdAt
      updatedAt
      __typename
    }
  }
`;
